import { paths as branchPaths } from './Branches/routers'
import { paths as dashboardPaths } from './Dashboard/routers'
import { paths as posPaths } from './POS/routers'
import { paths as productsPaths } from './Products/routers'
import { paths as clientsPaths } from './Clients/routers'
import { paths as SallerPaths } from '../Seller/routers'
import { paths as StocksPaths } from './Stocks/routers'
import { paths as FinancialPaths } from './Financial/routers'
import { paths as NFePaths } from '../Fiscal/NFe/routers'
import { paths as NFSePaths } from '../Fiscal/NFSe/routers'
import { paths as NFCePaths } from '../Fiscal/NFCe/routers'
import { paths as DigitalCertificatePaths } from './DigitalCertificate/routers'
import { paths as SettingsPaths } from './Settings/routers'
import { paths as ProfilePaths } from '../User/Profile/routers'
import { paths as AfilliationPaths } from '../User/Afilliation/routers'
import { paths as PlansPaths } from './Plans/routers'
import { paths as HelpPaths } from './Help/routers'
import { paths as SalesPaths } from './Sales/routers'
import { paths as TaxesPaths } from '../Fiscal/Taxes/routers'
import {paths as BarcodesPaths} from '../AppViews/Barcodes/routers'
import { paths as PurchasesPaths } from './Purchases/routers'
import {paths as News} from "../AppViews/News/routes"
import Dashboard from './Dashboard'

import DesignSystemExamples from './DesignSystemExamples.jsx';

export default []
    .concat(branchPaths)
    .concat(dashboardPaths)
    .concat(posPaths)
    .concat(productsPaths)
    .concat(clientsPaths)
    .concat(SallerPaths)
    .concat(StocksPaths)
    .concat(FinancialPaths)
    .concat(NFePaths)
    .concat(NFSePaths)
    .concat(NFCePaths)
    .concat(DigitalCertificatePaths)
    .concat(SettingsPaths)
    .concat(PlansPaths)
    .concat(ProfilePaths)
    .concat(AfilliationPaths)
    .concat(HelpPaths)
    .concat(SalesPaths)
    .concat(TaxesPaths)
    .concat(BarcodesPaths)
    .concat(PurchasesPaths)
    .concat(News)
    .concat(process.env.NODE_ENV === 'development' ? [{ path: "/ds/exemplos", component: DesignSystemExamples }] : [])
    .concat({ path: "*", component: Dashboard })



// WEBPACK FOOTER //
// ./src/views/AppViews/routers.js